import React, { useState, useEffect } from 'react'
import { Message, Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import pathname from '../../../constants/pathname'
import CKEditorFromFull from '../../../components/forms/input/CKEditorFromFull'
import { saveSettingFormProjectBackground } from '../../../redux/actions/subProjectFormSetting'
import { CANCEL, DEFAULT_ERR_MSG, SAVE, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import EditFormDescriptionWidget from '../dynamicForm/EditFormDescriptionWidget'
import { doneLoading, startLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'

export default function ProjectBackgroundSettingWidget(props) {
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [section, setSection] = useState()
  const [notiMsg, setNotiMsg] = useState()
  const [isRefash, setIsRefash] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [editorData, setEditorData] = useState()

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    // console.log('formSchema', formSchema)
    var data = formSchema.editorData.value

    formSchema?.mapFileData?.map((item) => {
      // console.log('item :', item)
      // console.log('item.key :', item.key.replace('[[', '').replace(']]', ''))
      if (item.link != null) {
        let link = `<a href="${item.link}" target="_blank"> ${item.key
          .replace('[[', '')
          .replace(']]', '')} </a>`
        data = data.replace(item.key, link)
      }
    })

    // console.log('data : ', data)

    setEditorData(data)
  }, [formSchema])

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveSettingFormProjectBackground(formId, request)
      if (response?.forms?.projectBackground) {
        setFormSchema(response.forms.projectBackground)
        setNotiMsg({
          type: 'success',
          msg: SAVE_SUCCESS_MSG,
        })
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
        onRefash()
      } else {
        setNotiMsg({
          type: 'error',
          msg: DEFAULT_ERR_MSG,
        })
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)
      setNotiMsg({
        type: 'error',
        msg: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
      })
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    doneLoading()
    setIsLoading(false)

    setTimeout(() => {
      setNotiMsg('')
    }, 2500)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []

    values.push({
      key: formSchema.editorData.id,
      name: formSchema.editorData.name,
      value: data.editorData,
      type: formSchema.editorData.type,
    })

    let request = {
      id: formSchema.id,
      values: values,
      descValues: data.descSettingValues || [],
      descDelIds: data.descDelIds || [],
    }
    console.log('request : ', request)

    handleSave(request)
  }

  const onRefash = () => {
    setIsRefash(true)
    scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      {!isRefash && (
        <>
          {formSchema.descriptionSetting && (
            <EditFormDescriptionWidget
              schema={formSchema.descriptionSetting}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          )}

          <CKEditorFromFull
            key={'form0'}
            schema={formSchema.editorData}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            getValues={getValues}
          />
        </>
      )}

      <hr />
      {notiMsg && (
        <Message
          closable
          showIcon
          type={notiMsg.type}
          description={notiMsg.msg}
          onClose={() => setNotiMsg('')}
          style={{ marginBottom: 10 }}
        />
      )}
      <div className="right">
        <ViewButton
          style={{
            marginRight: 10,
            marginBottom: 10,
          }}
          onClick={() => {
            window.open(`${pathname.subProjectNew.proposal.projectBackground}?preView`, '_blank')
          }}
          children={'แสดงตัวอย่าง'}
        />
        <SaveButton
          children={SAVE + (formSchema.buttonText || '')}
          disabled={isLoading}
          onClick={handleSubmit(onSubmit)}
        />
        <CancelButton children={CANCEL} onClick={onRefash} />
      </div>

      {isLoading && <OverlayLoader />}
    </Panel>
  )
}
